export default __webpack_public_path__ + "static/armand-22b45c15de1e8fb553bc51bc204b2456.jpg";